import {EntityWithIdAndDescription} from "../types/baseEntities";
import { HttpAxiosRequest } from "./httpAxiosRequest";

export const HttpCache = {
  getEndpoint: (url: string): string => `/cache${url}`,

  getProvincies: (): Promise<EntityWithIdAndDescription[]> =>
    HttpAxiosRequest.get<EntityWithIdAndDescription[]>(
      HttpCache.getEndpoint('/provincias')
    ),


    getCities: (): Promise<EntityWithIdAndDescription[]> =>
        HttpAxiosRequest.get<EntityWithIdAndDescription[]>(
            HttpCache.getEndpoint('/localidades')
    ),

    getCitiesByProvince: (provinceId: number): Promise<EntityWithIdAndDescription[]> =>
        HttpAxiosRequest.get<EntityWithIdAndDescription[]>(
            HttpCache.getEndpoint(`/localidades/${provinceId}`)
    ),

    getPersonTypes: (): Promise<EntityWithIdAndDescription[]> =>
        HttpAxiosRequest.get<EntityWithIdAndDescription[]>(
            HttpCache.getEndpoint('/persona-tipos')
    ),

    getIdentityDocumentTypes: (): Promise<EntityWithIdAndDescription[]> =>
        HttpAxiosRequest.get<EntityWithIdAndDescription[]>(
            HttpCache.getEndpoint('/documento-tipos')
    ),

}














